import { create } from 'zustand'

interface NavigationState {
  from?:
    | 'administrative-check'
    | 'permit-tracking'
    | 'overall-permits'
    | 'projects'
  setFrom: (from?: NavigationState['from']) => void
  clearFrom: () => void
}

export const useNavigationStore = create<NavigationState>((set) => ({
  from: undefined,
  setFrom: (from) => set({ from }),
  clearFrom: () => set({ from: undefined }),
}))
